export default __webpack_public_path__ + "static/pop-ai-dark-fdae5d40c036702c05eeef0bccd5784f.png";